import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { 
  Home, 
  About, 
  Archive, 
  Auth, 
  PostDetail, 
  WritePost, 
  NotFound 
} from './pages';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* 首页 */}
          <Route path="/" element={<Home />} />
          
          {/* 关于页面 */}
          <Route path="/about" element={<About />} />
          
          {/* 归档页面 */}
          <Route path="/archive" element={<Archive />} />
          
          {/* 登录注册页面 */}
          <Route path="/auth" element={<Auth />} />
          
          {/* 文章详情页面 */}
          <Route path="/post/:postId" element={<PostDetail />} />
          
          {/* 写文章页面 */}
          <Route path="/write" element={<WritePost />} />
          
          {/* 404页面 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;